import store from '@/store'
import ModuleBase from '../components/ModuleBase'
import StaffingDashboard from '../views/dashboard/Dashboard'
import ProfileOverview from '../views/profileDetail/Overview'

const routes = [
  {
    path: '/staffing/',
    component: ModuleBase,
    meta: { appKey: 'staffing' },
    children: [
      {
        path: 'dashboard',
        component: StaffingDashboard,
        name: 'StaffingDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'profile-detail/:id/',
        component: ProfileOverview,
        name: 'ProfileOverview'
      }
    ]
  }
]

export default routes
